import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { defaultFilmListAssets, filmListAssetsValidator } from './assets';
import { defaultFilmListCdnOptions, filmListCdnOptionsValidator } from './cdn-options';
import { defaultFilmListConfig, filmListConfigValidator } from './config';
import { defaultFilmListDisplayText, filmListDisplayTextValidator } from './display-text';
import { filmListEventsValidator } from './events';
export const filmListPropsValidator = Validator.object({
    config: filmListConfigValidator,
    displayText: filmListDisplayTextValidator,
    assets: filmListAssetsValidator,
    siteId: Validator.optional(nonEmptyStringValidator),
    events: filmListEventsValidator,
    cdnOptions: filmListCdnOptionsValidator
});
export const defaultFilmListProps = {
    config: defaultFilmListConfig,
    displayText: defaultFilmListDisplayText,
    assets: defaultFilmListAssets,
    siteId: undefined,
    events: {},
    cdnOptions: defaultFilmListCdnOptions
};
